// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2R5qO","title":"Header_title__2XqEf","side":"Header_side__2w8UZ"};